var render = function render(_c,_vm){return _c('div',_vm._b({class:[
    _vm.data.class,
    _vm.data.staticClass,
    _vm.props.withoutInsets ? '' : 'px-6 md:px-10',
    _vm.props.overrideClass ? _vm.props.overrideClass : 'container mx-auto w-full',
  ]},'div',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }